import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/Help.vue')
  },
  {
    path: '/legal',
    name: 'legal',
    component: () => import('../views/Legal.vue')
  },
  {
    path: '/report',
    name: 'report',
    component: () => import('../views/Report.vue')
  },

  // PUBLIC
  {
    path: '/advertise',
    name: 'advertise',
    component: () => import('../views/Advertise.vue')
  },
  {
    path: '/hire',
    name: 'hire',
    component: () => import('../views/Hire.vue')
  },
  {
    path: '/vehicle-rentals',
    name: 'vehicle-rentals',
    component: () => import('../views/VehicleCatalog.vue')
  },
  {
    path: '/property-rentals',
    name: 'property-rentals',
    component: () => import('../views/PropertyCatalog.vue')
  },
  {
    path: '/equipment-rentals',
    name: 'equipment-rentals',
    component: () => import('../views/EquipmentCatalog.vue')
  },

  // USER
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/Profile.vue')
  },

  // CATCH ALL
  {
    path: '*',
    name: 'uncharted',
    component: () => import(/* webpackChunkName: "about" */ '../views/Uncharted.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
